import { createUseStyles } from 'react-jss';

const styles = {
  // Role type switcher styles
  roleTypesList: {
    listStyle: 'none',
    margin: '0 0 2rem',
    padding: 0,

    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(17rem, 1fr))',
    gap: '3rem',
  },
  subtitle: {
    marginBottom: '4rem',
  },

  hiddenChangeAgencyFormWrapper: {
    display: 'none',
    maxHeight: 0,
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
